import * as actions from '../actions/applicationPolicy';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import sampleCombine from "xstream/extra/sampleCombine";
import {receiveApplicationPremiums, receivePatchedApplicationPremium} from '../reducers/stagedPremiums';
import {failedGetApplicationStagedPremiums, failedPatchApplicationStagedPremiumSettings, getApplicationStagedPremiums, receiveWizardApplicationStagedPremiums, requestPatchApplicationStagedPremiumSettings, successPatchApplicationStagedPremiumSettings} from '../reducers/stagedPremiumsWizard';


export function requestApplicationPolicyIPID(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_APPLICATION_POLICY_IPID)
		.map(action => ({
			url: BASE_URL + 'api/applications/'+  action.payload.policyId   +'/ipid',
			category: 'requestApplicationPolicyIPID',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestApplicationPolicyIPID')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.map(response =>  response.status === 200
			? actions.getApplicationPolicyIPIDSuccess(response)
			: actions.getApplicationPolicyIPIDFailed(response)
		);

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}



export function getApplicationNotificationAfterApplicationOverviewChange(sources) {
    const state$ = sources.STATE;
    const applicationId$ = state$.map(state => state.newApplication.selectedApplication.id);
    let action$ = sources.HTTP
        .select('postOverviewPolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .compose(sampleCombine(applicationId$))
        .map( ([response, applicationId]) => actions.requestApplicationNotification({applicationId: applicationId}));

    return {
        ACTION: action$,
    };
}

export function getApplicationNotificationAfterAragUserRequestUpdate(sources) {
    const state$ = sources.STATE;
    const applicationId$ = state$.map(state => state.newApplication.selectedApplication.id);
    let action$ = sources.HTTP
        .select('postUpdatePolicyForm')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .compose(sampleCombine(applicationId$))
		.map( ([response, applicationId]) => actions.requestApplicationNotification({applicationId: applicationId}));

    return {
        ACTION: action$,
    };
}

export function getApplicationNotificationAfterUpdate(sources) {
    let action$ = sources.HTTP
        .select('patchApplication')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.requestApplicationNotification({applicationId: response.body.id}));

    return {
        ACTION: action$,
    };
}

export function requestApplicationPolicyWording(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_APPLICATION_POLICY_WORDING)
        .map(action => ({
            url: BASE_URL + 'api/wording/'+ action.payload.wordingId ,
            category: 'requestApplicationPolicyWording',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestApplicationPolicyWording')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getApplicationPolicyWordingSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestApplicationPolicyWordingFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestApplicationPolicyWording')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getApplicationPolicyWordingFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function deleteApplicationDocument(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_DOCUMENT)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Attachments/' + action.payload.applicationId + '/' + action.payload.attachmentId
			+ (action.payload.relativeUrl==='overviewTab'?'?overview=true':'')
			+ (action.payload.relativeUrl==='updateTab'?'?update=true':'')
			+ (action.payload.relativeUrl==='disbursements'?'?disbursements=true':''),
			category: 'deleteApplicationDocument',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));

	let request2$ =  sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_DELETE_DOCUMENT)
		.map(action => ({
            payload: action.payload.attachmentId
		}));

	let httpResponse$ = sources.HTTP
		.select('deleteApplicationDocument')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)

    let httpResponseAction$ = xs.combine(request$, httpResponse$, request2$)
        .map(response => actions.receiveDeleteDocumentResponse(response[2].payload, response[1].body));

	return {
		ACTION: httpResponseAction$,
		HTTP: request$
	};
}

export function receiveBadRequestDeleteDocument(sources) {
	let httpResponse$ = sources.HTTP
		.select('deleteApplicationDocument')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestDeleteDocument(response));

	return {
		ACTION: httpResponse$
	};
}

export function getApplicationAttachments(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ALL_APPLICATION_ATTACHMENTS)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Attachments/' + action.payload ,
			category: 'getApplicationAttachments',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getApplicationAttachments')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveAllApplicationAttachments(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponseGetApplicationAttachments(sources) {
    let httpResponse$ = sources.HTTP
        .select('getApplicationAttachments')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetAllApplicationAttachments(response));

    return {
        ACTION: httpResponse$
    };
}

export function getApplicationAttachment(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_APPLICATION_ATTACHMENT)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.applicationId + '/Attachments/'+ action.payload.attachmentId +
			(action.payload.relativeUrl==='overviewTab'?'?overview=true': '') +
			(action.payload.relativeUrl==='updateTab'?'?update=true': '') +
			(action.payload.relativeUrl==='disbursements'?'?disbursements=true': ''),
			category: 'getApplicationAttachment',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getApplicationAttachment')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveApplicationAttachment(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponseGetApplicationAttachment(sources) {
    let httpResponse$ = sources.HTTP
        .select('getApplicationAttachment')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetApplicationAttachment(response));

    return {
        ACTION: httpResponse$
    };
}

export function getApplicationPremiumSettings(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_APPLICATION_PREMIUM_SETTINGS || action.type === getApplicationStagedPremiums.type)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.id + '/PremiumSettings' +
			( action.payload?.premiumType && action.payload?.premiumType != '' ?('?type='+ action.payload.premiumType):''),
			category: 'getApplicationSettings',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getApplicationSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => xs.of(actions.receiveApplicationPremiumSettings(response.body),receiveApplicationPremiums(response.body),
		receiveWizardApplicationStagedPremiums(response.body)))
		.flatten();

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestGetApplicationPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('getApplicationSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200 )
		.map(response => xs.of(actions.receiveBadRequestApplicationPremiumSettings(response),failedGetApplicationStagedPremiums()))
		.flatten();

	return {
		ACTION: httpResponse$,
	};
}

export function patchTransferApplicationBetweenSolicitors(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.applicationId + '/Transfer',
			category: 'patchTransferApplicationBetweenSolicitors',
			method: 'PATCH',
			send: action.payload.sendBody,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchTransferApplicationBetweenSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchTransferApplicationBetweenSolicitors(response.body));
	
	
	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPatchTransferApplicationBetweenSolicitors(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchTransferApplicationBetweenSolicitors')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestPatchTransferApplicationBetweenSolicitors(response));

	return {
		ACTION: httpResponse$,
	};
}

export function postApplicationPremiumSettings(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_APPLICATION_PREMIUM_SETTINGS)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.applicationId + '/PremiumSettings',
			category: 'postApplicationPremiumSettings',
			method: 'POST',
			send: action.payload.sendBody,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('postApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.receivePostApplicationPremiumSettings(response.body));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPostApplicationPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('postApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status >= 400)
		.map(response => actions.receiveBadRequestPostApplicationPremiumSettings(response.response.body.message));

	return {
		ACTION: httpResponse$,
	};
}

export function patchApplicationPremiumSettings(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS ||
			action.type === requestPatchApplicationStagedPremiumSettings.type)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.applicationId + '/PremiumSettings/'+ action.payload.sendBody.id,
			category: 'patchApplicationPremiumSettings',
			method: 'PATCH',
			send: action.payload.sendBody,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => xs.of(actions.receivePatchApplicationPremiumSettings(response.body),
		successPatchApplicationStagedPremiumSettings(response.body),
		receivePatchedApplicationPremium(response.body)))
		.flatten();

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPatchApplicationPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => xs.of(actions.receiveBadRequestPatchApplicationPremiumSettings(response),failedPatchApplicationStagedPremiumSettings(response)))
		.flatten();

	return {
		ACTION: httpResponse$,
	};
}

export function requestGoLiveAfterPremium(sources){
	const request1$ = sources.ACTION
		.filter(action => ((action.type === ActionTypes.REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS ||
				action.type === ActionTypes.REQUEST_POST_APPLICATION_PREMIUM_SETTINGS || action.type === requestPatchApplicationStagedPremiumSettings.type )
		))
		.map(action => action);

	const request2$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS ||
			action.type === ActionTypes.RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS
		)).map(action => action);
	const request$ = request2$
		.compose(sampleCombine(request1$))
		.filter(both => both[1].payload.makeApplicationLive === true)
		.map(both =>
			({
				url: BASE_URL + 'api/Applications/Forms/' + both[0].payload.applicationId,
				category: 'patchApplicationAfterPremium',
				method: 'PATCH',
				send: {
					id: both[0].payload.applicationId,
					policyStatus: "Live",
					sendEmail:both[0].payload.sendEmail
				},
				type: 'application/json',
				withCredentials: true
			}));

	let httpResponse$ = sources.HTTP
		.select('patchApplicationAfterPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => xs.of(actions.receivePatchApplicationAfterPremium(JSON.parse(response.text)),
		successPatchApplicationStagedPremiumSettings({changingApplicationStatus:false,...JSON.parse(response.text)})))
		.flatten();

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestGoLiveAfterPremium(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchApplicationAfterPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => xs.of(actions.receiveBadRequestPatchApplicationAfterPremium(response),failedPatchApplicationStagedPremiumSettings(response)))
		.flatten();

	return {
		ACTION: httpResponse$,
	};
}



//when the action to get the solicitor group after we get the selected app is dispatched,
//we make the GET request for the solicitor group
export function requestGetSolicitorGroupAfterAction(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITOR_GROUP_OF_APPLICATION)
        .map(action => ({
            url: BASE_URL + 'api/Groups/Solicitors/' + action.payload,
            category: 'requestGetSolicitorGroupAfterAction',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetSolicitorGroupAfterAction')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetSolicitorGroupOfApplication(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}



export function getApplicationNotification(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_APPLICATION_NOTIFICATION )
		.map(action => ({
			url: BASE_URL + 'api/Applications/'+action.payload.applicationId+'/Notification',
			category: 'getApplicationNotification',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getApplicationNotification')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveApplicationNotification(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failureApplicationNotification(sources) {
	let httpResponse$ = sources.HTTP
		.select('getApplicationNotification')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveFailureApplicationNotification(response));

	return {
		ACTION: httpResponse$
	};
}

export function getApplicationPolicySchedule(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_POLICY_SCHEDULE )
		.map(action => ({
			url: BASE_URL + 'api/Documents/' + action.payload.applicationId + '/Lawsys/' + 
			action.payload.lawsysId,
			category: 'getPolicySchedule',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getPolicySchedule')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response =>actions.receivePolicySchedule(response.text))
	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failGetPolicySchedule(sources) {
	let httpResponse$ = sources.HTTP
		.select('getPolicySchedule')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.failGetPolicySchedule(response));

	return {
		ACTION: httpResponse$
	};
}

export function deleteApplicationPremiumSettings(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS)
		.map(action => ({
			url: BASE_URL + 'api/Applications/' + action.payload.applicationId + '/PremiumSettings/' + action.payload.appPremiumSettingId,
			category: 'deleteApplicationPremiumSettings',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));


	let httpResponse$ = sources.HTTP
		.select('deleteApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status == 200)
		.map(response => actions.receiveDeleteApplicationPremiumSettings(response));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestDeleteApplicationPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('deleteApplicationPremiumSettings')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestDeleteApplicationPremiumSettings(response));

	return {
		ACTION: httpResponse$
	};
}